import pluralize from 'pluralize';

export default function petTypeOptionItems(count) {
  return [
    { value: 'dog', label: `${pluralize('Dog', count)}` },
    { value: 'cat', label: `${pluralize('Cats', count)}` },
  ];
}
